import React from "react";
import {
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  Grid,
} from "@mui/material";

import moment from "moment";
import { Alarm } from "@phosphor-icons/react";

const EmailReschedul = ({
  OpenDialog,
  handleClose,
  setSelecteddate,
  selecteddate,
  timeerror,
  selectedtime,
  handleTimeChange,
  handleReschedule,
  isDisabled,
}) => {
  const selectedTimeForInput = moment(selectedtime, "h:mm A").format("HH:mm");
  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        Reschedule
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          className="mt-3"
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <label for="formFile" className="form-label fs-13">
                Date
              </label>
              <input
                value={selecteddate}
                className="form-control fs-13"
                onChange={(e) => setSelecteddate(e.target.value)}
                type="date"
                min={new Date().toISOString().split("T")[0]}
              />
            </Grid>
            <Grid item xs={6}>
              <label for="formFile" className="form-label fs-13">
                Time
              </label>
              <input
                value={selectedTimeForInput}
                className="form-control fs-13"
                onChange={handleTimeChange}
                type="time"
                min={new Date()
                  .toLocaleTimeString([], {
                    hour12: false,
                  })
                  .slice(0, 5)}
              />

              {timeerror ? (
                <span
                  className="text-danger"
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Can Not Reschedule Before Current Time *
                </span>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleReschedule}
          disabled={isDisabled()}
          endIcon={<Alarm size={15} weight="bold" />}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="contained"
          size="small"
          disableElevation
          onClick={handleReschedule}
        >
          Reschedule
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailReschedul;
